import React from "react";
import { formatDateToMonthStringAndYear } from "../../../../shared/utils";
import SalesListHeaderBoxValue from "./SalesListHeaderBoxValue";

const SalesListReceivedHeader = props => {
	return (
		<div className="sales-list-header__boxes__content__values__block-of-status-contents">
			<SalesListHeaderBoxValue
				value={props.value}
				isFetching={props.isFetching}
				title={`${formatDateToMonthStringAndYear(
					props.startFilteredDate
				)} - ${formatDateToMonthStringAndYear(props.endFilteredDate)}:`}
			/>
			<SalesListHeaderBoxValue
				value={props.totalMiles}
				isDecimal={true}
				isFetching={props.isFetching}
				title="Milhas vendidas:"
			/>
		</div>
	);
};

export default SalesListReceivedHeader;
